import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_NOTIFICATIONS: '/NotificationLists',
  SEND_NOTIFICATION: '/SendNotificationNeigboorhood',
  // Yalnız seçili ilçe + mahallelerdeki vatandaşlara; SendNotificationNeigboorhood Tip doluyken herkese gönderir
  SEND_NOTIFICATION_ILCE_MAHALLE: '/SendNotificationIlceMahalle',
  // Tümü: adresi olan herkese, vatandaş başına tek bildirim (eski uç adres başına gönderiyor)
  SEND_NOTIFICATION_TUM_VATANDAS: '/SendNotificationTumVatandas',
};

export const getNotifications = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_NOTIFICATIONS);
  return response.data;
};

// Send notification to neighborhoods
// Parameters (FormData):
// - Mahalleler: string (comma-separated neighborhood names)
// - Mesaj: string
// - Tip: string ('Tümü' or 'Mahalle')
// - image: File (optional)
// 
export const sendNotification = async (formData) => {
  const response = await axiosInstance.post(ENDPOINTS.SEND_NOTIFICATION, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Send notification only to citizens in the selected districts' neighborhoods
// Parameters (FormData):
// - IlceMahalleler: string "İLÇE|MAHALLE" (names), appended once per selected neighborhood;
//   neighborhood names are not unique across districts
// - Mesaj: string
// - image: File (optional)
// (API still accepts the older single-district form: Ilce + Mahalleler)
export const sendNotificationIlceMahalle = async (formData) => {
  const response = await axiosInstance.post(ENDPOINTS.SEND_NOTIFICATION_ILCE_MAHALLE, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Send notification to every citizen with an address, once per citizen
// Parameters (FormData):
// - Mesaj: string
// - image: File (optional)
export const sendNotificationTumVatandas = async (formData) => {
  const response = await axiosInstance.post(ENDPOINTS.SEND_NOTIFICATION_TUM_VATANDAS, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
